import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TokenApi } from "./token.api";
import { AgentTokenInfo } from "./token.types";

@Injectable({ providedIn: "root" })
export class TokenService {
  constructor(private readonly tokenApi: TokenApi) {}

  getMyAgentToken(): Observable<string | null> {
    return this.tokenApi.getMyAgentToken();
  }

  generateMyAgentToken(): Observable<string> {
    return this.tokenApi.generateMyAgentToken();
  }

  removeMyAgentToken(): Observable<boolean> {
    return this.tokenApi.removeMyAgentToken();
  }

  getAllAgentTokens(): Observable<Array<AgentTokenInfo>> {
    return this.tokenApi.getAllAgentTokens();
  }

  removeAgentTokenByAccount(accountId: string): Observable<boolean> {
    return this.tokenApi.removeAgentTokenByAccount(accountId);
  }
}
